<template>
  <div class="stage_data">
    <div v-if="stage.norm_stage == 1">
      <span class="label">
        Причина:
      </span>
      <span class="value">
        {{ stage.reason }}
      </span>
    </div>
    <div v-if="stage.norm_stage == 2">
      <span class="label">
        Вид документа:
      </span>
      <span class="value">
        {{ stage.kind_by_law }}
      </span>
    </div>
    <div v-if="stage.norm_stage == 3">
      <span class="label">
        {{ stage.kind_by_law }}:
      </span>
      <span class="value">
        <router-link
          :to="$i18nRoute({ name: 'view-npa', params: { id: stage.link } })"
          target="_blank"
        >
          {{ stage.name }}
        </router-link>
      </span>
    </div>
    <div v-if="stage.norm_stage == 4">
      <span class="label">
        Номер документа:
      </span>
      <span class="value">
        {{ stage.name }}
      </span>
    </div>
    <div v-if="stage.norm_stage == 5">
      <a
        target="_blank"
        v-if="currentLocaleUrl == '/ru'"
        :href="'http://cbd.minjust.gov.kg/act/view/ru-ru/' + stage.cbd_link + '/10'"
      >
        {{ stage.name }}
      </a>
      <a
        v-else
        target="_blank"
        :href="'http://cbd.minjust.gov.kg/act/view/ru-ru/' + stage.cbd_link + '/10?cl=ky-kg'"
      >
        {{ stage.name }}
      </a>
    </div>
  </div>
</template>
<script>
import { Trans } from "@/plugins/Translation"
  export default {
    name: 'LawNormViewStageTableData',
    props: {
      stage: {
        type: Object,
        required: true
      }
    },

    computed: {
      currentLocaleUrl () {
        return Trans.currentLocaleUrl
      }
    }
  }
</script>
